/* Frannkly — micro-movements
   Reveals sections as they scroll into view. Off-screen elements start hidden;
   anything already visible at load is left untouched (no flash, no jump). */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // respect reduced-motion: no reveal animations
  }

  var SELECTOR = [
    '.sourcing__text',
    '.sourcing__media',
    '.coffee-grid__header',
    '.coffee-grid__card',
    '.why__lead',
    '.why__front',
    '.purpose-feature__intro',
    '.purpose-feature__photo',
    '.purpose-feature__aside',
    '.three-fronts__head',
    '.three-fronts__card',
    '.sister-cta__inner',
    '.cause-quote__inner',
    '.sp__chapter',
    '.sp__docs',
    '.sp__quote',
    '.sp__promise',
    '.sp__two',
    '.sp__closing'
  ].join(',');

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!els.length || !('IntersectionObserver' in window)) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;

    // Stagger cards within the coffee grid
    document.querySelectorAll('.coffee-grid__cards').forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (card, i) {
        card.style.transitionDelay = (i % 4) * 80 + 'ms';
      });
    });

    // Stagger the three-fronts cards as they rise in
    document.querySelectorAll('.three-fronts__grid').forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (card, i) {
        card.style.transitionDelay = i * 110 + 'ms';
      });
    });

    // Stagger the Anna & Frank collage photos
    Array.prototype.slice.call(document.querySelectorAll('.purpose-feature__photo')).forEach(function (p, i) {
      p.style.transitionDelay = i * 90 + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top > vh * 0.82) {
        el.classList.add('reveal'); // only pre-hide what's below the fold
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
